import { useQuery } from '@apollo/client';
import { ReactNode, useMemo } from 'react';
import { Control, FieldPathByValue, FieldValues } from 'react-hook-form';

import { GetLosIdsForCompanyDocument } from '@willow/graphql-iso/src/app';
import { CompanyId, LosId } from '@willow/types-iso';

import { ControlledSelect } from './ControlledSelect';

type Props<T extends FieldValues> = {
  companyId: CompanyId;
  fieldName: FieldPathByValue<T, boolean | string | number | undefined | null>;
  control: Control<T>;
  hideErrorMessage?: boolean;
  label?: ReactNode;
  placeholder?: string;
  required?: boolean;
};

interface LosSelectOption {
  label: LosId;
  value: LosId;
}

export function ControlledLosIdSingleSelect<T extends FieldValues>(props: Props<T>) {
  const { companyId } = props;
  const { data } = useQuery(GetLosIdsForCompanyDocument, { variables: { companyId } });
  const losOptions: LosSelectOption[] = useMemo(
    () =>
      (data?.company.loanIdentifiers ?? []).map((loan) => ({
        value: loan.losId,
        label: loan.losId,
      })),
    [data?.company.loanIdentifiers],
  );

  return <ControlledSelect options={losOptions} {...props} />;
}
